export const NO_ACTIVE_CONTRACT = 'No active contract';
export const NO_SERVICES_FOUND = 'No services found';

/** Interval (ms) for proactive token-bridge refresh. Used by useAuth(alwaysFresh = true). */
export const PROACTIVE_REFRESH_INTERVAL_MS = 60_000;
